import axios from "@/plugins/axios";

let url = "/api/console/platforms/topping";

export const topping = {
    get(data){
        return axios.get(`${url}`, data).then(result => result.data);
    },
}